<template>
    <div class="sidebar-detail__section" v-if="!noResults">
        <div class="sidebar__section sidebar-detail__subtitle bold-small-label">
            <span>Verkehrsmeldungen</span>
            <Loader class="sidebar-detail__subtitle__loader" v-if="loading" />
        </div>
        <POIList 
            :pois="messages"
            :loading="loading"
            :more-loading="moreLoading"
            current-sorting="DISTANCE_ASC"
            :no-results-icon="noResultsIcon"
            @load-more="loadMoreHandler"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import * as api from '@/api';
import { getPOIResultByType} from '@/utils/poi-utils'
import { getPoiConfig } from '@/utils/poi-data/poi-config'
import { formatRouteTimeForPoi } from '@/utils/route-utils'
import { getChangedValues, checkForChanges } from '@/utils/changes'
import { getPoiParams } from '@/utils/poi-params';
import Loader from '@/components/Loader.vue'
import POIList from '@/components/POIList.vue'

export default {
    components: {
        Loader,
        POIList,
    },
    props: {
        route: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            messages: {'traffic': []},
            loading: false,
            moreLoading: false,
            more: false,
            hasLoadedOnce: false,            
        }
    },
    computed: {
        ...mapGetters(['routeTrafficTime', 'detailRouteId']),
        noResultsIcon() {
            return getPoiConfig('traffic').icon;
        },
        noResults() {
            return !this.loading && this.hasLoadedOnce && this.messages.traffic.length === 0
        }
    },
    watch: {
        route(newVal, oldVal) {
            const changedFieldsToIgnore = ['gasPrice']
            const changedFields = Object.keys(getChangedValues(newVal, oldVal))
            if(checkForChanges(changedFieldsToIgnore, changedFields).length) this.reloadTrafficMessages()
        }
    },
    mounted() {
        this.loadTrafficMessages();
    },
    beforeDestroy() {
        if(!this.detailRouteId) {
            // eventBus.$emit('removePoisFromMap', {type: 'traffic'})
            if(this.loading) {
                api.poi.cancelPOIrequest('traffic');
            }
        }
    },
    methods: {
        loadMoreHandler(e) {
            this.loadMore(e.counts);
        },
        reloadTrafficMessages() {
            this.messages.traffic = []
            this.hasLoadedOnce = false
            this.more = false
            this.loadTrafficMessages()
        },
        async loadTrafficMessages() {
            const type = 'traffic';
            const apiType = getPoiConfig(type).apiType;
            const params = getPoiParams(type);
            if(!params.type) params.type = {}
            params.type.values = ['Baustelle', 'Schneeketten', 'Sperre', 'Wintersperre', 'Störung', 'Verkehr', 'Stau', 'Straßenzustand'];
            if(!this.routeTrafficTime.isNow) {
                params.time = formatRouteTimeForPoi(this.routeTrafficTime)
            }
            // park & ride should only show traffic for the first section
            if(this.route.mode === 'PARK_AND_RIDE') {
                params.geographic.corridor.polylineWKT = this.route.polylines[0].polyline
            }
            if(!params.geographic.corridor) params.geographic.corridor = {}
            params.geographic.corridor.radius = 0.15
            this.loading = true;
            try {
                await this.loadListTrafficMessages(apiType, params, type);
                const responseMap = await api.poi.getPOIsForMapByType(apiType, params);
                const dataMap = getPOIResultByType(responseMap, type);
                eventBus.$emit('removePoisFromMap', {type})
                eventBus.$emit('showPoisOnMap', {type, data: dataMap})
            } catch(e) {
                console.error(e);
            } finally {
                this.loading = false;
                this.hasLoadedOnce = true
                this.$emit('trafficMessagesLoaded', this.messages.traffic.length > 0)
            }

        },

        async loadListTrafficMessages(apiType, params, type, offset = false) {
            const responseList = await api.poi.getPOIsForListByType(apiType, {...params}, false, offset);
            const dataList = getPOIResultByType(responseList, type);
            this.messages.traffic = [...this.messages.traffic, ...dataList];
            if(responseList.data && responseList.data.header && responseList.data.header.count) {
                this.more = responseList.data.header.count < responseList.data.header.totalCount;
            }
            return responseList;
        },

        async loadMore(counts) {
            if(!this.more) return;
            this.moreLoading = true;
            const type = 'traffic';
            const apiType = getPoiConfig(type).apiType;
            const params = getPoiParams(type);
            if(!params.type) params.type = {}
            params.type.values = ['Baustelle', 'Schneeketten', 'Sperre', 'Wintersperre', 'Störung', 'Verkehr', 'Stau', 'Straßenzustand'];
            if(!params.geographic.corridor) params.geographic.corridor = {}
            params.geographic.corridor.radius = 0.15
            try {
                await this.loadListTrafficMessages(apiType, params, type, counts.traffic);
            } catch(e) {
                console.error(e);
            } finally {
                this.moreLoading = false;
            }
            // await this.$store.dispatch('loadMorePOIResults', counts);
        },
    }
}
</script>

<style lang="scss">
</style>